import { render, staticRenderFns } from "./TierPrices.vue?vue&type=template&id=8d294a82&scoped=true&"
import script from "./TierPrices.vue?vue&type=script&lang=js&"
export * from "./TierPrices.vue?vue&type=script&lang=js&"
import style0 from "./TierPrices.vue?vue&type=style&index=0&id=8d294a82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d294a82",
  null
  
)

export default component.exports